import React, {useEffect, useState} from "react";
import PropTypes from 'prop-types'
import JsonScreenHoc from "../../../../../HocHelpers/JsonScreenHoc";
import {getParamsFromString} from '../../../Utils'
import request from "../../../../../Services/API/Requests";
import Screen from "../../Screen";
import Loading from "../../../../../Utils/Loading/Loading";
import {useSelector} from "react-redux";

const EmbeddedScreen = ({screenId, basePath, styles, doActions, screenName}) => {
    const sourceStyles = styles ? styles[0] : {};
    const {globalValues} = useSelector(state => state.jsonScreen);
    const [screen, setScreen] = useState(null);
    const [loading, setLoading] = useState(false);
    const parsedId = getParamsFromString(screenId, globalValues, screenName);
    useEffect(() => {
        async function readScreen() {
            try {
                if (!parsedId) {
                    setScreen(null)
                    return;
                }
                setLoading(true);
                const response = await request({
                    url: "screen/read",
                    method: "POST",
                    data: {id: parsedId}
                });
                setScreen(response);
                setLoading(false);
                if (response.events && response.events.length) {
                    for (let event of response.events) {
                        if (event.event === 'onOpen') {
                            doActions(event.actions)
                        }
                    }
                }
            } catch (e) {
                setScreen(null);
                setLoading(false);
                console.log(e)
            }
        }

        readScreen()
    }, [parsedId]);

    return (
        <div
            style={{
                width: sourceStyles.width,
                height: sourceStyles.height,
            }}
            className={sourceStyles.className}
            id={parsedId + '_embedded'}>
            {loading && <Loading/>}
            {screen && !loading && (
                <Screen
                    screen={screen}
                    basePath={basePath}
                />
            )}
        </div>
    )
};

export default JsonScreenHoc(EmbeddedScreen);

EmbeddedScreen.propTypes = {
    basePath: PropTypes.string,
    screenId: PropTypes.string,
    styles: PropTypes.array
};